function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import inputRules from '@/mixins/input-rules';
import ActionParametersEditDialog from './actionParametersEditDialog.vue';
export default {
  name: 'ActionsEditor',
  components: {
    ActionParametersEditDialog: ActionParametersEditDialog
  },
  mixins: [inputRules],
  props: {
    value: {
      type: Array,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      "default": function _default() {}
    }
  },
  data: function data() {
    return {
      newActionLabel: '',
      newActionAction: null,
      actionParametersOpenedIndex: null,
      addFormValid: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    definedActions: function definedActions() {
      var clone = cloneDeep(this.value);
      return Array.isArray(clone) ? clone : [];
    },
    actionDefinitions: function actionDefinitions() {
      return [{
        type: 'url.open',
        text: this.$t('Dashboards.components.actionsEditor.actions.url.open.label'),
        parameters: [{
          key: 'url',
          label: this.$t('Dashboards.components.actionsEditor.actions.url.open.parameters.url.label'),
          type: 'string'
        }, {
          key: 'openInNewTab',
          label: this.$t('Dashboards.components.actionsEditor.actions.url.open.parameters.newTab.label'),
          type: 'boolean',
          "default": true
        }]
      }, {
        type: 'twin.open',
        text: this.$t('Dashboards.components.actionsEditor.actions.twin.open.label'),
        parameters: [{
          key: 'useOpenedTwin',
          label: this.$t('Dashboards.components.actionsEditor.actions.twin.open.parameters.useOpenedTwin.label'),
          type: 'boolean',
          "default": true
        }, {
          key: 'twinId',
          label: this.$t('Dashboards.components.actionsEditor.actions.twin.open.parameters.twinId.label'),
          type: 'twin.id',
          "if": '!useOpenedTwin'
        }, {
          key: 'openInNewTab',
          label: this.$t('Dashboards.components.actionsEditor.actions.twin.open.parameters.newTab.label'),
          type: 'boolean',
          "default": true
        }]
      }, {
        type: 'dashboard.open',
        text: this.$t('Dashboards.components.actionsEditor.actions.dashboard.open.label'),
        parameters: [{
          key: 'nestedDashboard',
          type: 'nestedDashboard'
        }]
      }];
    },
    openedActionParameterDefinitions: function openedActionParameterDefinitions() {
      var _this = this;
      if (!this.showActionParametersDialog) {
        return [];
      }
      var actionDefinition = this.actionDefinitions.find(function (actionItem) {
        return actionItem.type === _this.definedActions[_this.actionParametersOpenedIndex].action;
      });
      if (!actionDefinition) {
        console.error('Action definition not found');
        return [];
      }
      return actionDefinition.parameters || {};
    },
    showActionParametersDialog: {
      get: function get() {
        return this.actionParametersOpenedIndex !== null;
      },
      set: function set(value) {
        if (value) {
          throw new Error('Cannot open the dialog like this...');
        }
        this.actionParametersOpenedIndex = null;
      }
    },
    openedAction: function openedAction() {
      return this.definedActions[this.actionParametersOpenedIndex] || {};
    }
  }),
  methods: {
    addNewAction: function addNewAction() {
      if (!this.addFormValid) {
        this.$refs.addForm.validate();
        return;
      }
      var newAction = {
        label: this.newActionLabel,
        action: this.newActionAction,
        parameters: {}
      };
      var newActions = [].concat(_toConsumableArray(this.definedActions), [newAction]);
      this.$emit('input', newActions);
    },
    updateAction: function updateAction(index, key, value) {
      var clone = cloneDeep(this.value);
      set(clone, "[".concat(index, "].").concat(key), value);
      this.$emit('input', clone);
    },
    openActionParameters: function openActionParameters(index) {
      this.actionParametersOpenedIndex = index;
    },
    removeAction: function removeAction(index) {
      var newActions = this.definedActions.filter(function (_, i) {
        return i !== index;
      });
      this.$emit('input', newActions);
    },
    onParametersUpdated: function onParametersUpdated(parameters) {
      this.updateAction(this.actionParametersOpenedIndex, 'parameters', parameters);
      this.actionParametersOpenedIndex = null;
    }
  }
};